import React from "react";
import PropTypes from "prop-types";
import CSSModules from "react-css-modules";
import ImmutablePropTypes from "react-immutable-proptypes";

import arrow from "../../../../images/arrow.svg";

import { isBotxoDomain } from "../../../../utils/rebranding";

import styles from "./style.cssmodule.scss";

const isPrevDomain = isBotxoDomain();

const DropdownMenuItem = ({ data, itemClick, index }) => {
  const onClick = () => itemClick(data, index);

  const handleKeyPress = e => {
    if (e.key === "Enter") {
      itemClick(data, index);
    }
  };

  const type = data.get("type");

  const menuItemContainer = isPrevDomain
    ? styles["dropdown-menu-item-component"]
    : styles.ndMenuItemContainer;

  return (
    <div
      className={menuItemContainer}
      onClick={onClick}
      onKeyPress={handleKeyPress}
      role="link"
      tabIndex={0}
    >
      {data.get("label")}
      {type === 2 && (
        <span className={styles.arrow}>
          <img src={arrow} alt="arrow" className={styles.img} />
        </span>
      )}
    </div>
  );
};

DropdownMenuItem.displayName = "DropdownButtonMenuItem";
DropdownMenuItem.propTypes = {
  data: ImmutablePropTypes.map,
  itemClick: PropTypes.func,
  index: PropTypes.number,
};
DropdownMenuItem.defaultProps = {};

export default CSSModules(DropdownMenuItem, styles);
